export default __webpack_public_path__ + "static/media/yearbook.1f1987b6.svg";